import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import { Toaster } from './components/ui/sonner';
import AppLayout from './components/AppLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DeviceMonitor from './pages/DeviceMonitor';
import DeviceDetail from './pages/DeviceDetail';
import Alerts from './pages/Alerts';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import ServiceTickets from './pages/ServiceTickets';
import TicketDetail from './pages/TicketDetail';
import MaintenancePlans from './pages/MaintenancePlans';
import Technicians from './pages/Technicians';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';

function Protected({ children }) {
  const { user } = useApp();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Router() {
  const { user } = useApp();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <AppLayout />
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="devices" element={<DeviceMonitor />} />
        <Route path="devices/:id" element={<DeviceDetail />} />
        <Route path="alerts" element={<Alerts />} />
        <Route path="customers" element={<Customers />} />
        <Route path="customers/:id" element={<CustomerDetail />} />
        <Route path="tickets" element={<ServiceTickets />} />
        <Route path="tickets/:id" element={<TicketDetail />} />
        <Route path="plans" element={<MaintenancePlans />} />
        <Route path="technicians" element={<Technicians />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Router />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
